const Footer = () => {
	return (
		<footer className="footer text-center">
			Task Manager &copy; Todos los derechos reservados
		</footer>
	);
};
export default Footer;
